var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ul',{staticClass:"menu"},[_vm._l((_vm.menuList),function(item,index){return _c('li',{key:index,class:{'active':_vm.menu_index===index},on:{"click":function($event){_vm.menu_index=index}}},[_vm._v(_vm._s(item.label))])}),_c('div',{staticClass:"title"},[_vm._v("(签收统计：2021-07-10 - 2021-07-25)")])],2),_c('formTable')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }